"use client";

import type { FC } from "react";
import { cn } from "utils";
import { FITNESS_SCORE_RESULT_COPY } from "../onboardingWizardCopy";

export interface FitnessDimensionScoreCardProps {
  control: number;
  safety: number;
  growth: number;
  animate?: boolean;
  barWidths?: {
    control: number;
    safety: number;
    growth: number;
  };
  barLabelValues?: {
    control: number;
    safety: number;
    growth: number;
  };
}

const ROWS = [
  {
    key: "control" as const,
    label: FITNESS_SCORE_RESULT_COPY.dimensions.control,
  },
  {
    key: "safety" as const,
    label: FITNESS_SCORE_RESULT_COPY.dimensions.safety,
  },
  {
    key: "growth" as const,
    label: FITNESS_SCORE_RESULT_COPY.dimensions.growth,
  },
];

export const FitnessDimensionScoreCard: FC<FitnessDimensionScoreCardProps> = ({
  control,
  safety,
  growth,
  animate = false,
  barWidths,
  barLabelValues,
}) => {
  const values = { control, safety, growth };
  const widths = barWidths ?? values;
  const labels = barLabelValues ?? values;

  return (
    <div
      className="w-full rounded-3 bg-background_solid_neutral_primary p-4"
      data-testid="fitness-dimension-score-card"
      data-figma-node="97267:68857"
    >
      <p className="body_bold_m text-content_primary">
        {FITNESS_SCORE_RESULT_COPY.cardTitle}
      </p>
      <div className="mt-5 flex flex-col gap-3">
        {ROWS.map((row) => {
          const value = values[row.key];
          const width = animate ? widths[row.key] : value;
          const labelValue = animate ? labels[row.key] : value;

          return (
            <div key={row.key} className="flex items-center gap-3">
              <p className="body_medium_m w-16 shrink-0 text-content_primary">
                {row.label}
              </p>
              <div
                className={cn(
                  "relative h-1.5 min-w-0 flex-1 overflow-hidden rounded-full",
                  "bg-background_neutral_overlay10 md:bg-border_inverse_transparent10",
                )}
              >
                <div
                  className="absolute inset-y-0 left-0 rounded-full bg-content_brand_primary"
                  style={{ width: `${width}%` }}
                />
              </div>
              <p className="body_medium_m w-[26px] shrink-0 text-right text-content_primary tabular-nums">
                {labelValue}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
